import React from "react";
import ReactDOM from "react-dom";
import {loadScript} from "./constants/functions";
import {GOOGLE_MAPS_API_KEY} from "./constants/constants";
import Header from "./components/Header";
import Footer from "./components/Footer";
import registerServiceWorker from "./registerServiceWorker";
import App from "./App";

import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "./index.css";

ReactDOM.render(<App/>, document.getElementById('main'));
ReactDOM.render(<Footer/>, document.getElementById('footer'));
ReactDOM.render(<Header/>, document.getElementById('header'));
loadScript(`https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}`);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js